import { render, staticRenderFns } from "./ExplanationOfPayment.vue?vue&type=template&id=fec58b58&scoped=true"
import script from "./ExplanationOfPayment.vue?vue&type=script&lang=js"
export * from "./ExplanationOfPayment.vue?vue&type=script&lang=js"
import style0 from "./ExplanationOfPayment.vue?vue&type=style&index=0&id=fec58b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec58b58",
  null
  
)

export default component.exports